import React from 'react'

// import './content.css'
import Navigator from '../../navigation/Navigator'

function Content() {
  return (
    <div className="content">
      <Navigator />
    </div>
  )
}


export default Content